export const formatName = (firstName, middleName, lastName, title) => {
  const lastNameFirstName = [];
  if (!isNull(lastName)) {
    lastNameFirstName.push(lastName);
  }
  if (!isNull(firstName)) {
    lastNameFirstName.push(firstName);
  }

  return `${lastNameFirstName.join(", ")} ${!isNull(middleName) ? middleName : ""} ${!isNull(title) ? " - " + title: ""}`;
}

export const isNull = (str) => {
  return str === null || str === undefined || str.toString().toUpperCase() === "NULL" || str === "";
}

export const updateFormFieldToPrompt = (field) => {
  const FIELD_TO_PROMPT = {
    "occupation": "What is your Occupation?",
    "districtOffice": "What's your district office address?",
    "districtPhone": "What's your district office phone?",
    "districtFax": "If you have a district office fax, please provide it.",
    "staff": "Staff Names, Titles and EMail addresses",
    "phone": "State House Phone # or Cell #",
    "fax": "State House Fax #",
    "email": "Legislative Email Address",
    "bluesky ": "Bluesky handle",
    "twitter": "X handle",
    "threads ": "Threads handle",
    "facebook": "Facebook handle",
    "instagram": "Instagram handle",
    "bluesky": "Bluesky handle",
    "threads": "Threads handle",
    "website ": "Website URL",
    "_DNU_committees": "Legislative Committee membership,",
    "HomeAddress": "Home Address",
    "DateOfBirth": "Date of Birth",
    "PlaceOfBirth": "Birthplace",
    "maritalStatus": "Marital Status",
    "Previous": "Previous Employment/Past Experience",
    "VeteranService": "Military service",
    "PoliticalOffices": "Past/Other Political Offices",
    "Organizations": "Organizations/Memberships",
    "Priorities": "Legislative and professional priorities",
    "quote": "A favorite quote",
  };

  if (FIELD_TO_PROMPT[field]) {
    return FIELD_TO_PROMPT[field];
  }

  return capitalize(field);
}

export const updateFormFieldToDefaultValue = (field) => {
  const FIELD_TO_DEFAULT_VALUE = {
    "city": "Boston",
    "state": "MA",
    "zip": "02133",
  };

  return FIELD_TO_DEFAULT_VALUE[field];
}

export const capitalize = (str) => {
  if (typeof str !== "string" || str.length === 0) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
